import React from 'react'
import { ReactSVG } from 'react-svg'
import * as styles from './Button.module.scss'

interface BaseButtonProps {
  variant?: 'primary' | 'secondary'
  size?: 'xs' | 'small' | 'medium' | 'large'
  disabled?: boolean
  showLeadIcon?: boolean
  showTrailIcon?: boolean
  leadIconSrc?: string
  trailIconSrc?: string
  className?: string
  href?: string
}

export type ButtonProps = BaseButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>

export const Button = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonProps>(
  (
    {
      children,
      disabled = false,
      className = '',
      size = 'large',
      variant = 'primary',
      showLeadIcon = false,
      showTrailIcon = false,
      leadIconSrc = '/img/icons/chevron-left.svg',
      trailIconSrc = '/img/icons/chevron-right.svg',
      href,
      ...props
    },
    ref
  ) => {
    const Component = href ? 'a' : 'button'

    const componentProps = href
      ? { href, className: `${styles.button} ${styles[variant]} ${styles[size]} ${className}`, ref, ...props }
      : { disabled, className: `${styles.button} ${styles[variant]} ${styles[size]} ${className}`, ref, ...props }

    return (
      <Component {...(componentProps as any)}>
        {showLeadIcon && (
          <span>
            <ReactSVG src={leadIconSrc} />
          </span>
        )}
        <span>{children}</span>
        {showTrailIcon && (
          <span>
            <ReactSVG src={trailIconSrc} />
          </span>
        )}
      </Component>
    )
  }
)

export type { ButtonProps as BaseButtonProps }
